// Authentication
export const SET_USER = 'SET_USER'
export const SET_HOST = 'SET_HOST'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_USER_PROP = 'SET_USER_PROP'
export const SET_HOST_PROP = 'SET_HOST_PROP'
export const SET_VISITOR_LOCATION = 'SET_VISITOR_LOCATION'
export const SET_AUTH_MODAL_OPEN = 'SET_AUTH_MODAL_OPEN'
export const SET_AUTH_REDIRECT = 'SET_AUTH_REDIRECT'

// Events
export const SET_EVENTS_LOADED = 'SET_EVENTS_LOADED'
export const SET_ALL_EVENTS = 'SET_ALL_EVENTS'
export const SET_FILTERED_EVENTS = 'SET_FILTERED_EVENTS'
export const SET_EVENT_TAGS = 'SET_EVENT_TAGS'
export const SET_EVENT_PROP = 'SET_EVENT_PROP'
export const SET_EVENT_FILTER = 'SET_EVENT_FILTER'
export const SET_EVENT_SEARCH_LOCATION = 'SET_EVENT_SEARCH_LOCATION'
export const SET_FILTERED_EVENT_PROP = 'SET_FILTERED_EVENT_PROP'
export const ADD_EVENT = 'ADD_EVENT'
export const SET_NEED_TO_FETCH_EVENTS = 'SET_NEED_TO_FETCH_EVENTS'
export const SET_CURRENT_EVENT = 'SET_CURRENT_EVENT'
export const SET_CURRENT_EVENT_HOST = 'SET_CURRENT_EVENT_HOST'

// Notifications
export const SET_NOTIFICATION_TEXT = 'SET_NOTIFICATION_TEXT'
export const SET_NOTIFICATION_ACTIVE = 'SET_NOTIFICATION_ACTIVE'
export const SET_NOTIFICATION_LINK_ROUTE = 'SET_NOTIFICATION_LINK_ROUTE'
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'
export const SET_NOTIFICATION_READ = 'SET_NOTIFICATION_READ'

// Alerts
export const SET_ALERT_TEXT = 'SET_NOTIFICATION_TEXT'
export const SET_ALERT_ACTIVE = 'SET_NOTIFICATION_ACTIVE'
export const SET_ALERT_LINK_ROUTE = 'SET_NOTIFICATION_LINK_ROUTE'

// Locations
export const SET_ALL_LOCATIONS = 'SET_ALL_LOCATIONS'
export const ADD_LOCATION = 'ADD_LOCATION'
export const SET_CURRENT_LOCATION = 'SET_CURRENT_LOCATION'

// -- API -- //
// event_location_api
export const FETCH_ALL_EVENTS = 'FETCH_ALL_EVENTS'
export const FETCH_ALL_LOCATIONS = 'FETCH_ALL_LOCATIONS'

// Host
export const SET_HOST_HELP_OPEN = 'SET_HOST_HELP_OPEN'
export const SET_HOST_INFO_PROP = 'SET_HOST_INFO_PROP'
export const SET_LOCATION_PROP = 'SET_LOCATION_PROP'
export const SET_ADD_LOCATION_IMAGES_URL = 'SET_ADD_LOCATION_IMAGES_URL'

// Host
export const REMOVE_PARTIAL_EVENT = 'REMOVE_PARTIAL_EVENT'
export const SET_PARTIAL_EVENTS = 'SET_PARTIAL_EVENTS'
export const SET_ADD_EVENT_STATE = 'SET_ADD_EVENT_STATE'
export const REMOVE_PARTIAL_LOCATION = 'REMOVE_PARTIAL_LOCATION'
export const SET_PARTIAL_LOCATIONS = 'SET_PARTIAL_LOCATIONS'
export const SET_ADD_LOCATION_STATE = 'SET_ADD_LOCATION_STATE'
export const SET_LAST_HOST_APPLY_STEP = 'SET_LAST_HOST_APPLY_STEP'
export const SET_ADD_EVENT_WRKPRTY_TYPE = 'SET_ADD_EVENT_WRKPRTY_TYPE'
export const SET_ADD_EVENT_TITLE = 'SET_ADD_EVENT_TITLE'
export const SET_ADD_EVENT_HOUSE_RULES = 'SET_ADD_EVENT_HOUSE_RULES'
export const SET_ADD_EVENT_DESCRIPTION = 'SET_ADD_EVENT_DESCRIPTION'
export const SET_ADD_EVENT_DATE = 'SET_ADD_EVENT_DATE'
export const SET_ADD_EVENT_TIME = 'SET_ADD_EVENT_TIME'
export const SET_ADD_EVENT_SEATS = 'SET_ADD_EVENT_SEATS'
export const SET_ADD_EVENT_PRICE = 'SET_ADD_EVENT_PRICE'
export const SET_ADD_EVENT_FREQUENCY = 'SET_ADD_EVENT_FREQUENCY'
export const SET_ADD_EVENT_WOMEN_ONLY = 'SET_ADD_EVENT_WOMEN_ONLY'
export const SET_ADD_EVENT_PARENTS_ONLY = 'SET_ADD_EVENT_PARENTS_ONLY'
export const SET_ADD_EVENT_AGE_RANGE_MIN = 'SET_ADD_EVENT_AGE_RANGE_MIN'
export const SET_ADD_EVENT_AGE_RANGE_MAX = 'SET_ADD_EVENT_AGE_RANGE_MAX'
export const SET_ADD_EVENT_EVENT_TAG_VALUE = 'SET_ADD_EVENT_EVENT_TAG_VALUE'
export const SET_ADD_EVENT_EVENT_TAG_VALUES = 'SET_ADD_EVENT_EVENT_TAG_VALUES'
export const SET_ADD_EVENT_PRE_WRKPRTY_ACTIVE =
	'SET_ADD_EVENT_PRE_WRKPRTY_ACTIVE'
export const SET_ADD_EVENT_PRE_WRKPRTY_PRICE = 'SET_ADD_EVENT_PRE_WRKPRTY_PRICE'
export const SET_ADD_EVENT_PRE_WRKPRTY_DESCRIPTION =
	'SET_ADD_EVENT_PRE_WRKPRTY_DESCRIPTION'
export const SET_ADD_EVENT_DURING_WRKPRTY_ACTIVE =
	'SET_ADD_EVENT_DURING_WRKPRTY_ACTIVE'
export const SET_ADD_EVENT_DURING_WRKPRTY_PRICE =
	'SET_ADD_EVENT_DURING_WRKPRTY_PRICE'
export const SET_ADD_EVENT_DURING_WRKPRTY_DESCRIPTION =
	'SET_ADD_EVENT_DURING_WRKPRTY_DESCRIPTION'
export const SET_ADD_EVENT_POST_WRKPRTY_ACTIVE =
	'SET_ADD_EVENT_POST_WRKPRTY_ACTIVE'
export const SET_ADD_EVENT_POST_WRKPRTY_PRICE =
	'SET_ADD_EVENT_POST_WRKPRTY_PRICE'
export const SET_ADD_EVENT_POST_WRKPRTY_DESCRIPTION =
	'SET_ADD_EVENT_POST_WRKPRTY_DESCRIPTION'
export const SET_ADD_EVENT_NOTES = 'SET_ADD_EVENT_NOTES'
export const SET_ADD_EVENT_RULES = 'SET_ADD_EVENT_RULES'
export const SET_ADD_EVENT_IMAGES = 'SET_ADD_EVENT_IMAGES'
export const SET_ADD_EVENT_IMAGES_URLS = 'SET_ADD_EVENT_IMAGES_URLS'
export const SET_ADD_EVENT_IMAGES_URL = 'SET_ADD_EVENT_IMAGES_URL'
export const SET_ADD_EVENT_PROP = 'SET_ADD_EVENT_PROP'
export const SET_ADD_EVENT_SPONSOR = 'SET_ADD_EVENT_SPONSOR'
export const SET_ADD_EVENT_VALID_STEP = 'SET_ADD_EVENT_VALID_STEP'
export const REMOVE_ADD_EVENT_VALID_STEP = 'REMOVE_ADD_EVENT_VALID_STEP'
export const SET_ADD_LOCATION_VALID_STEP = 'SET_ADD_LOCATION_VALID_STEP'
export const REMOVE_ADD_LOCATION_VALID_STEP = 'REMOVE_ADD_LOCATION_VALID_STEP'
export const SET_ADD_EVENT_INVALID_STEP = 'SET_ADD_EVENT_INVALID_STEP'
export const REMOVE_ADD_EVENT_INVALID_STEP = 'REMOVE_ADD_EVENT_INVALID_STEP'
export const SET_ADD_LOCATION_INVALID_STEP = 'SET_ADD_LOCATION_INVALID_STEP'
export const REMOVE_ADD_LOCATION_INVALID_STEP =
	'REMOVE_ADD_LOCATION_INVALID_STEP'
export const ADD_EVENT_RESET_STATE = 'ADD_EVENT_RESET_STATE'
export const ADD_LOCATION_RESET_STATE = 'ADD_LOCATION_RESET_STATE'

// Other
export const OPEN_PURCHASE_ADDON_MODAL = 'OPEN_PURCHASE_ADDON_MODAL'
export const OPEN_PURCHASE_ADDON_SUCCESS_MODAL = 'OPEN_PURCHASE_ADDON_SUCCESS_MODAL'
export const SET_DONT_TRIGGER_POP = 'SET_DONT_TRIGGER_POP'
export const OPEN_RSVP_SUCCESS_MODAL = 'OPEN_RSVP_SUCCESS_MODAL'
export const SET_MODAL_PROP = 'SET_MODAL_PROP'
export const POP_ACTIVE_MODAL = 'POP_ACTIVE_MODAL'
export const SET_ACTIVE_MODAL = 'SET_ACTIVE_MODAL'
export const SET_EVENT_RSVP_MODAL_EVENT = 'SET_EVENT_RSVP_MODAL_EVENT'
export const SET_SHARE_MODAL_EVENT = 'SET_SHARE_MODAL_EVENT'
export const SET_SHARE_MODAL_OPEN = 'SET_SHARE_MODAL_OPEN'
export const SET_CALENDAR_MODAL_EVENT = 'SET_CALENDAR_MODAL_EVENT'
export const SET_CALENDAR_MODAL_OPEN = 'SET_CALENDAR_MODAL_OPEN'
export const SET_EVENT_RSVP_SUCCESS_MODAL_OPEN =
	'SET_EVENT_RSVP_SUCCESS_MODAL_OPEN'
export const SET_CONTACT_FORM_OPEN = 'SET_CONTACT_FORM_OPEN'
export const SET_EDIT_EVENT_CONTACT_FORM_OPEN =
	'SET_EDIT_EVENT_CONTACT_FORM_OPEN'
export const SET_EDIT_EVENT_CONTACT_FORM_EVENT =
	'SET_EDIT_EVENT_CONTACT_FORM_EVENT'
export const SET_TERMS_MODAL_OPEN = 'SET_TERMS_MODAL_OPEN'
export const SET_TERMS_PAGE = 'SET_TERMS_PAGE'
export const SET_PRIVACY_MODAL_OPEN = 'SET_PRIVACY_MODAL_OPEN'
export const SET_GENERIC_MODAL_OPEN = 'SET_GENERIC_MODAL_OPEN'
export const SET_PAYMENT_MODAL_OPEN = 'SET_PAYMENT_MODAL_OPEN'
export const SET_PAYMENT_MODAL_EVENT = 'SET_PAYMENT_MODAL_EVENT'
export const SET_PAYMENT_MODAL_STATUS = 'SET_PAYMENT_MODAL_STATUS'
export const SET_MEMBERSHIP_UPSELL_MODAL_OPEN =
	'SET_MEMBERSHIP_UPSELL_MODAL_OPEN'
export const SET_MEMBERSHIP_UPSELL_MODAL_EVENT =
	'SET_MEMBERSHIP_UPSELL_MODAL_EVENT'
export const SET_GENERIC_MODAL_TEXT = 'SET_GENERIC_MODAL_TEXT'
export const SET_GENERIC_MODAL_TITLE = 'SET_GENERIC_MODAL_TITLE'
export const SET_MOBILE_NAV_ACTIVE = 'SET_MOBILE_NAV_ACTIVE'
export const SET_SNACKBAR_OPEN = 'SET_SNACKBAR_OPEN'
export const SET_SNACKBAR_TEXT = 'SET_SNACKBAR_TEXT'

// Admin
export const SET_ADMIN_PROP = 'SET_ADMIN_PROP'
